var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"lazy-image",rawName:"v-lazy-image",value:(_vm.src),expression:"src"}],staticClass:"bpos-lazy-image",attrs:{"src":_vm.placeholder,"alt":_vm.alt},on:{"error":_vm.handleError}})}
var staticRenderFns = []

export { render, staticRenderFns }